import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileTextIcon, BookIcon, GraduationCapIcon, MessageSquareIcon, BarChart2Icon, ClipboardCheckIcon, PackageIcon, HelpCircleIcon, ArrowRightIcon, SearchIcon, BellIcon, UserIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
export function CustomerSupportPage() {
  const navigate = useNavigate();
  // Mock data for recent claims
  const recentClaims = [{
    id: '202534704',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL'
  }, {
    id: '202528724',
    type: 'Missing part',
    status: 'Pending',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN'
  }, {
    id: '202523188',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC'
  }];
  // Mock data for support metrics
  const supportMetrics = {
    openClaims: 37,
    resolvedClaims: 98,
    avgResponseTime: '3.2 days',
    totalDocuments: 256
  };
  return <div className="min-h-screen bg-gray-100" data-id="element-7834">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-7835">
        <div className="container mx-auto px-6 py-8" data-id="element-7836">
          <div className="flex justify-between items-center mb-6" data-id="element-7837">
            <h1 className="text-3xl font-bold" data-id="element-7838">Customer Support</h1>
            <div className="flex items-center space-x-4" data-id="element-7839">
              <div className="relative" data-id="element-7840">
                <input type="text" placeholder="Search support resources..." className="pl-10 pr-4 py-2 bg-blue-900/30 border border-blue-800/30 rounded-lg text-white placeholder-blue-300 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-7841" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={18} data-id="element-7842" />
              </div>
              <div className="relative" data-id="element-7843">
                <BellIcon size={22} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-7844" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-7845">
                  2
                </span>
              </div>
              <div className="bg-blue-800/30 rounded-full w-9 h-9 flex items-center justify-center" data-id="element-7846">
                <UserIcon size={20} className="text-white" data-id="element-7847" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-7848">
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-7849">
              <div className="bg-blue-800/30 p-3 rounded-lg mr-4" data-id="element-7850">
                <ClipboardCheckIcon size={24} className="text-blue-300" data-id="element-7851" />
              </div>
              <div data-id="element-7852">
                <p className="text-blue-300 text-sm" data-id="element-7853">Open Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-7854">
                  {supportMetrics.openClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-7855">
              <div className="bg-teal-800/30 p-3 rounded-lg mr-4" data-id="element-7856">
                <CheckCircleIcon size={24} className="text-teal-300" data-id="element-7857" />
              </div>
              <div data-id="element-7858">
                <p className="text-blue-300 text-sm" data-id="element-7859">Resolved Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-7860">
                  {supportMetrics.resolvedClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-7861">
              <div className="bg-amber-700/30 p-3 rounded-lg mr-4" data-id="element-7862">
                <ClockIcon size={24} className="text-amber-300" data-id="element-7863" />
              </div>
              <div data-id="element-7864">
                <p className="text-blue-300 text-sm" data-id="element-7865">Avg. Response Time</p>
                <h3 className="text-2xl font-bold" data-id="element-7866">
                  {supportMetrics.avgResponseTime}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-7867">
              <div className="bg-indigo-800/30 p-3 rounded-lg mr-4" data-id="element-7868">
                <BookIcon size={24} className="text-indigo-300" data-id="element-7869" />
              </div>
              <div data-id="element-7870">
                <p className="text-blue-300 text-sm" data-id="element-7871">Support Documents</p>
                <h3 className="text-3xl font-bold" data-id="element-7872">
                  {supportMetrics.totalDocuments}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8" data-id="element-7873">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-7874">
          {/* Left Column - Support Services */}
          <div className="lg:col-span-2 space-y-8" data-id="element-7875">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-7876">
              Support Services
            </h2>
            {/* Claims Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-7877">
              <div className="p-6 border-b border-gray-100" data-id="element-7878">
                <div className="flex items-start" data-id="element-7879">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-7880">
                    <FileTextIcon size={24} className="text-blue-600" data-id="element-7881" />
                  </div>
                  <div className="flex-1" data-id="element-7882">
                    <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-7883">
                      Claims Management
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-7884">
                      Submit and track warranty claims, missing parts, or
                      technical issues
                    </p>
                    <div className="flex flex-wrap gap-3" data-id="element-7885">
                      <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/new')} data-id="element-7886">
                        Report New Claim
                      </button>
                      <button className="px-4 py-2 bg-white border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/reports')} data-id="element-7887">
                        View Claims Reports
                        <ChevronRightIcon size={18} className="ml-1" data-id="element-7888" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Recent Claims */}
              <div className="bg-gray-50 px-6 py-4" data-id="element-7889">
                <h4 className="text-sm font-medium text-gray-500 mb-3 flex items-center" data-id="element-7890">
                  <BarChart2Icon size={16} className="mr-2" data-id="element-7891" />
                  RECENT CLAIMS
                </h4>
                <div className="space-y-2" data-id="element-7892">
                  {recentClaims.map(claim => <div key={claim.id} className="flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200" data-id="element-7893">
                      <div className="flex items-center" data-id="element-7894">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={18} className="text-green-500 mr-2" data-id="element-7895" /> : claim.status === 'Pending' ? <ClockIcon size={18} className="text-amber-500 mr-2" data-id="element-7896" /> : <AlertCircleIcon size={18} className="text-red-500 mr-2" data-id="element-7897" />}
                        <div data-id="element-7898">
                          <div className="font-medium text-gray-800" data-id="element-7899">
                            {claim.id}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-7900">
                            {claim.dealer} • {claim.date}
                          </div>
                        </div>
                      </div>
                      <div data-id="element-7901">
                        <span className={`text-xs px-2 py-1 rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Pending' ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800'}`} data-id="element-7902">
                          {claim.status}
                        </span>
                      </div>
                    </div>)}
                </div>
                <div className="mt-3 text-center" data-id="element-7903">
                  <button className="text-blue-600 text-sm font-medium hover:text-blue-800 flex items-center mx-auto" onClick={() => navigate('/support/claims/reports')} data-id="element-7904">
                    View All Claims
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-7905" />
                  </button>
                </div>
              </div>
            </div>
            {/* Knowledge Base Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7906">
              {/* Aisco Library */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-teal-900 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-7907">
                <div className="p-6" data-id="element-7908">
                  <div className="flex items-center mb-4" data-id="element-7909">
                    <div className="bg-blue-800/30 p-3 rounded-lg mr-3" data-id="element-7910">
                      <BookIcon size={24} className="text-white" data-id="element-7911" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-7912">Aisco | LIBRARY</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-7913">
                    Access our complete collection of product documentation,
                    technical manuals, catalogs, and brochures in multiple
                    languages.
                  </p>
                  <div className="mt-auto" data-id="element-7914">
                    <button className="w-full px-4 py-3 bg-blue-800/30 hover:bg-blue-800/50 border border-blue-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-7915">
                      Browse Documentation
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-7916" />
                    </button>
                  </div>
                </div>
                <div className="bg-blue-900/50 px-6 py-3 flex justify-between items-center" data-id="element-7917">
                  <span className="text-sm text-blue-200" data-id="element-7918">
                    256 documents available
                  </span>
                  <span className="text-xs bg-blue-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-7919">
                    Updated Weekly
                  </span>
                </div>
              </div>
              {/* Aisco School */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-7920">
                <div className="p-6" data-id="element-7921">
                  <div className="flex items-center mb-4" data-id="element-7922">
                    <div className="bg-indigo-800/30 p-3 rounded-lg mr-3" data-id="element-7923">
                      <GraduationCapIcon size={24} className="text-white" data-id="element-7924" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-7925">Aisco | SCHOOL</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-7926">
                    Enhance your technical skills with our expert-led courses.
                    Learn at your own pace and get certified on our irrigation
                    systems.
                  </p>
                  <div className="mt-auto" data-id="element-7927">
                    <button className="w-full px-4 py-3 bg-indigo-800/30 hover:bg-indigo-800/50 border border-indigo-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-7928">
                      Start Learning
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-7929" />
                    </button>
                  </div>
                </div>
                <div className="bg-indigo-900/50 px-6 py-3 flex justify-between items-center" data-id="element-7930">
                  <span className="text-sm text-blue-200" data-id="element-7931">
                    24 courses available
                  </span>
                  <span className="text-xs bg-indigo-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-7932">
                    Certification Available
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column - Support Resources */}
          <div className="space-y-8" data-id="element-7933">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-7934">
              Support Resources
            </h2>
            {/* Feedback Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-7935">
              <div className="p-6" data-id="element-7936">
                <div className="flex items-center mb-4" data-id="element-7937">
                  <div className="bg-purple-100 p-3 rounded-lg mr-3" data-id="element-7938">
                    <MessageSquareIcon size={24} className="text-purple-600" data-id="element-7939" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-7940">Feedback</h3>
                </div>
                <p className="text-gray-600 mb-6" data-id="element-7941">
                  Help us improve Aisco Workspace by sharing your experience and
                  suggestions.
                </p>
                <button className="w-full px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors shadow-sm font-medium" data-id="element-7942">
                  Submit Feedback
                </button>
              </div>
            </div>
            {/* Quick Support Links */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200" data-id="element-7943">
              <div className="p-6" data-id="element-7944">
                <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-7945">
                  Quick Support
                </h3>
                <div className="space-y-3" data-id="element-7946">
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-7947">
                    <div className="bg-blue-100 p-2 rounded-lg mr-3" data-id="element-7948">
                      <HelpCircleIcon size={20} className="text-blue-600" data-id="element-7949" />
                    </div>
                    <div data-id="element-7950">
                      <div className="font-medium text-gray-800" data-id="element-7951">FAQ</div>
                      <div className="text-xs text-gray-500" data-id="element-7952">
                        Frequently asked questions
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-7953">
                    <div className="bg-green-100 p-2 rounded-lg mr-3" data-id="element-7954">
                      <PackageIcon size={20} className="text-green-600" data-id="element-7955" />
                    </div>
                    <div data-id="element-7956">
                      <div className="font-medium text-gray-800" data-id="element-7957">
                        Parts Catalog
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-7958">
                        Browse replacement parts
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-7959">
                    <div className="bg-amber-100 p-2 rounded-lg mr-3" data-id="element-7960">
                      <ClipboardCheckIcon size={20} className="text-amber-600" data-id="element-7961" />
                    </div>
                    <div data-id="element-7962">
                      <div className="font-medium text-gray-800" data-id="element-7963">
                        Warranty Information
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-7964">
                        Warranty terms and conditions
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Support */}
            <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white border border-blue-800/30" data-id="element-7965">
              <div className="p-6" data-id="element-7966">
                <h3 className="text-xl font-bold mb-4" data-id="element-7967">Need Help?</h3>
                <p className="text-blue-200 mb-6" data-id="element-7968">
                  Our support team is available to assist you with any questions
                  or issues.
                </p>
                <div className="space-y-3" data-id="element-7969">
                  <button className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors font-medium" data-id="element-7970">
                    Contact Support
                  </button>
                  <button className="w-full px-4 py-3 bg-transparent border border-blue-700/50 text-white rounded-lg hover:bg-blue-800/20 transition-colors" data-id="element-7971">
                    Schedule a Call
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}